import { render, staticRenderFns } from "./PanelInvoice.vue?vue&type=template&id=fb5ad0d2&scoped=true&"
import script from "./PanelInvoice.vue?vue&type=script&lang=js&"
export * from "./PanelInvoice.vue?vue&type=script&lang=js&"
import style0 from "./PanelInvoice.vue?vue&type=style&index=0&id=fb5ad0d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5ad0d2",
  null
  
)

export default component.exports